import { render, staticRenderFns } from "./FetchProduct.vue?vue&type=template&id=2316108e&scoped=true"
import script from "./FetchProduct.vue?vue&type=script&lang=js"
export * from "./FetchProduct.vue?vue&type=script&lang=js"
import style0 from "./FetchProduct.vue?vue&type=style&index=0&id=2316108e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2316108e",
  null
  
)

export default component.exports